import React from 'react';
import createClass from 'create-react-class';
import {filter} from 'lodash';
import {Button} from 'ui-library';
import i18n from 'i18n';
import BrandChip from 'modules/accounts/advertiser/components/BrandOption/BrandOption';
import SelectableChip from 'modules/shared/components/SelectableChip/SelectableChip';
import OwnershipTransferDialog from 'modules/brands/advertiser/containers/OwnershipTransferDialog';
import BrandDeleteConfirmation from 'modules/brands/advertiser/containers/BrandDeleteConfirmation';
import {SettingsDropdown} from 'modules/legacy/js/lib/components';

const BrandSelector = createClass({
  getInitialState() {
    return {selectedBrand: null};
  },

  showOwnershipTransferDialog(brand) {
    const {showModal} = this.props;
    showModal(<OwnershipTransferDialog brandId={brand.id} />);
  },

  showBrandDeleteConfirmation(brand) {
    const {showModal} = this.props;
    showModal(<BrandDeleteConfirmation brandId={brand.id} />);
  },

  render() {
    const {accounts, user, onCancelDelete} = this.props;
    const {_id: userId} = user;
    const {selectedBrand} = this.state;
    const ownedBrands = filter(accounts, o => o.ownerId === userId);

    const menuStyle = {
      position: 'absolute',
      top: '1rem',
      right: '1rem'
    };

    const userBrands = ownedBrands.map((brand) => {
      const options = [
        {
          value: i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_USER_OWNEDBRAND_DELETE_OPTION'),
          callback: () => this.showBrandDeleteConfirmation(brand)
        },
        {
          value: i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_USER_OWNEDBRAND_TRANSFER_OPTION'),
          callback: () => this.showOwnershipTransferDialog(brand)
        }
      ];


      return (
        <div className='col-xs-3'>
          <div style={menuStyle} >
            <SettingsDropdown options={options} />
          </div>
          <SelectableChip
            className='margin-vertical-1x'
            isSelected={selectedBrand === brand.id}
          >
            <BrandChip brand={brand} />
          </SelectableChip>
        </div>
      );
    });

    return (
      <div >
        <div>
          <div className='margin-vertical-1x'><span>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_STEP1_LABEL')}</span></div>
          <div className='margin-vertical-1x'><span>{i18n.get('ADV_SETTINGS_ACCOUNT_DELETE_DELETE_ADVERTISER_STEP2_LABEL')}</span></div>
        </div>
        <div className='col'>
          <div className='col-md-8 vf-row margin-vertical-1x'>{userBrands}</div>
          <div className='col-md-4' />
        </div>
        <div className='vf-row padding-left-2x'>
          <div className='col-md-8 vf-row margin-vertical-1x'>
            <Button size='sm' color='default' onClick={onCancelDelete}>
              {i18n.get('INF_SETTINGS_ACCOUNT_DELETE_CANCEL_BUTTON_LABEL')}
            </Button>
          </div>
          <div className='col-md-4 flex' />
        </div>
      </div>
    );
  }
});

export default BrandSelector;
